import {  FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import { KTSVG } from "../../../smallnation/helpers";
import { Link } from 'react-router-dom';

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import {  useLocation, useHistory } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UsNumberValidate from "../../modules/utility/usNumberValidate";
//import Quick_links from "../../modules/utility/Quick_links";

const PerksList: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [companyProf, setCompanyProfile] = useState([]);
  const [companyinfo, setCompanyInfo] = useState([]);
  const [companyDisplayName, setCompanyDisplayName] = useState([]);
  const red = "red";
  var companytitle_name;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  //const companyId = queryParams.get('companyId');
 // const companyId = '135';
  const companyId = queryParams.get('companyId');
  const [userList, setUsersList] = useState([]);

  const [perkCategory, sePerkCategory] = useState([]);
 const [perkList, sePerkList] = useState([]);
    const [existingPerks, setExistingPerks] = useState([]);

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  var perkIdExisting = [];
    const getPerkCategoryList = () => {
        services.getPerkCategoryList().then((res) => {
          console.log("Industry data=" + JSON.stringify(res.data));
          var perks_unsort = res.data;
          console.log("Industry data=" + JSON.stringify(perks_unsort));  
            var perks_sorted = perks_unsort.sort((a, b) => a.perkCategoryOrderId - b.perkCategoryOrderId);
          sePerkCategory(perks_sorted);

        });
      }

      const getPerksByCatId = (perkCatId) => {
        services.getPerksByCategoryId(perkCatId).then((res) => {
          if(res.data){
            sePerkList(res.data);

            //alert(JSON.stringify(existingPerks))
            //alert(JSON.stringify(perkIdExisting))


            $('input[name="perkIdInfo"]').prop("checked", false);
            $('input[name="perkIdInfo"]').attr("checked", "false");
            setTimeout(() => {
                for (var i = 0; i < perkIdExisting.length; i++) {
                  //$("input[value='" + val + "']").prop('checked', true);
                  console.log("###" + perkIdExisting[i]);
                  //$('input[name="perkIdInfo"][value="' + perkIdExisting[i] + '"]').trigger("click");
                  $('input[name="perkIdInfo"][value="' + perkIdExisting[i] + '"]').prop("checked", true);
                  $('input[name="perkIdInfo"][value="' + perkIdExisting[i] + '"]').attr("checked", "true");
                }

              }, 1000);

            $("#addPerksBtnDiv").show();
          }

        });
      }


const getCompanyProfileInfo = (companyId) => {
        services.adminGetCompanyProfile(companyId).then((res) => {
            console.log("#####44");
          if(res.data){
            var existingperks_unsort = res.data.perksList;
            var existingperks_sorted = existingperks_unsort.sort((a, b) => a.perkCategoryOrderId - b.perkCategoryOrderId);
            setExistingPerks(existingperks_sorted);

            var ptemp =  res.data.perksList;
            var ptemAr = [];
            perkIdExisting = [];
            for(var p=0;p<ptemp.length;p++){
                 console.timeLog("#####52");
                 ptemAr.push(ptemp[p].perksId);
                 perkIdExisting.push(ptemp[p].perksId);
            }
            console.log("#####52");
            console.log(JSON.stringify(ptemAr));
           // setPerkIdExisting(ptemAr);
            //alert(JSON.stringify(ptemAr));


           /*
            setTimeout(() => {

                alert("87"+JSON.stringify(perkIdExisting));
                alert("87"+JSON.stringify(existingPerks));
              }, 3000);
           */



          }

        });
      }


  function validateCheck() {
    //alert("test");
  }


  const addPerkstoCompany = () => {

    var pcId = $("#perkCategoryId").val();
    var companyUserPerkSelectArray = [];
    $.each($("input[name='perkIdInfo']:checked"), function(){
        companyUserPerkSelectArray.push($(this).val());
    });
    const requestObject=
    {

        "siteId": 2,
        "companyId": companyId,
        "parkCategoryId": pcId,
        "parkList": companyUserPerkSelectArray

    }

    var accessTokenIn=sessionStorage.getItem("adminAccToken");
   const requestOptions = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json',
                                    'Authorization': "Bearer "+accessTokenIn
                                    //'Authorization': accessTokenIn
                                    },
                            body: JSON.stringify(requestObject)
                        };
    services.addPerksToCompany(requestOptions).then((res) =>
    {
      if (res.code == '200') {
        $("#successMessage").fadeTo(2000, 500).slideUp(500, function () {
            $("#successMessage").slideUp(500);
          });
        setTimeout(() => {getCompanyProfileInfo(companyId);}, 1000);
      }
        else{
          $("#failMessage").fadeTo(2000, 500).slideUp(500, function () {
            $("#failMessage").slideUp(500);
          });
          setTimeout(() => { }, 1000);
        }
    });
}

const removeCompanyPerk = () => {

    var companyUserPerkArray = [];

    $.each($("input[name='companyuserperk']:checked"), function(){
        companyUserPerkArray.push($(this).val());
    });

    const requestObject=
    {

        "siteId": 2,
        "companyId": companyId,
        "parkList": companyUserPerkArray

    }

   console.log(requestObject);
   var accessTokenIn=sessionStorage.getItem("adminAccToken");
   const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json',
              'Authorization': "Bearer "+accessTokenIn
              //'Authorization': accessTokenIn
            },
    body: JSON.stringify(requestObject)
};

services.deletePerkFromCompany(requestOptions).then((res) =>
{
  if (res.code == '200') {
        $("#successMessageDel").fadeTo(2000, 500).slideUp(500, function () {
            $("#successMessageDel").slideUp(500);
          });
      setTimeout(() => {getCompanyProfileInfo(companyId);}, 1000);
    }
    else{
      $("#failMessageDel").fadeTo(2000, 500).slideUp(500, function () {
        $("#failMessageDel").slideUp(500);
      });
  setTimeout(() => { }, 1000);
    }



});


    //setTimeout(() => {getCompanyUsers();}, 1000);

}

const getCompanyUsers = () => {
    services.adminGetUserInfo(companyId).then((res) => {
        console.log("Company Users=" + JSON.stringify(res.data));
        //setCompanyUsers(res.data.userList);
        //setCompanyUsers(res.data.data);
    });
}

const submitValue = () => {

    const requestObject=
    {
        // "userId": 62,
        "siteId":2,
        "companyId": companyId,
        // "schoolId": null,
        // "countyId": null,
        "firstName": $("#firstName").val(),
        "lastName": $("#lastName").val(),
        "email": $("#email").val(),
        "password": $("#password").val()
        // "phone": "9948684068",
        // "isStudent": "yes",
        // "status": null,
        // "userType": "company",
        // "createdOn": "2021-04-15T18:30:00.000+00:00",
        // "updatedOn": "2021-04-15T18:30:00.000+00:00"

    }

   console.log(requestObject);
   var accessTokenIn=sessionStorage.getItem("adminAccToken");
   const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json',
              'Authorization': "Bearer "+accessTokenIn
              //'Authorization': accessTokenIn
            },
    body: JSON.stringify(requestObject)
};



}


  useEffect(() => {
    if(companyId == null || companyId == "null"){
        //navigate('/login');
        //navigate('/login');
        window.location.assign('/login');
      }
      $('#perkValidMsg').hide();
      $("#successMessage").hide();
      $('#failMessage').hide();
      $("#addPerksBtnDiv").hide();
      $("#successMessageDel").hide();
      $('#failMessageDel').hide();
      getPerkCategoryList();
      getCompanyProfileInfo(companyId);

      $( "#perkCategoryId" ).change(function() {
        var pcId = $("#perkCategoryId").val();
        getPerksByCatId(pcId);
      });

      $( "#removeCompanyPerk" ).click(function() {

        removeCompanyPerk();
      });

      $( "#addPerksBtn" ).click(function() {

        addPerkstoCompany();
      });



}, []);
  return (

    <>
      <PageTitle breadcrumbs={[]}>{companyDisplayName}</PageTitle>
      <form   onSubmit={handleSubmit(submitValue)}>
             <div className="container px-0">
               <div className="row">
               <h3 className="mb-7">Perk List</h3>

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Perks Category</label>

                 </div>
                 <select className="form-select" aria-label="select example" id="perkCategoryId" name="perkCategoryId" >
                    <option selected value=''>Select</option>
                    {
                    perkCategory.map((data, index) => (
                        <option selected value={data.perkCategoryId}>{data.perkTitle}</option>
                    ))}
                 </select>
                                <div id="perkValidMsg" style={{color:red}} className="error">Please select at least 1 category.</div>
              </div>
                 </div>
                 <div id="addPerksBtnDiv">

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 </div>
                 <div  className="row mt-2 category-check-perks">
                 <ul className="row category-perks">
                {
                    perkList.map((data, index) => (
                    <li className=" col-md-4 form-check form-check-custom form-check-solid py-2"><input className="form-check-input" name="perkIdInfo" type="checkbox" value={data.perksId} id="perkId"/> <span> <img src={data.perksImageUrl} alt="" /></span> <label className="form-check-label" htmlFor="defaultCheck1"> {data.perksTitle} </label></li>
                ))}


                </ul>
                 </div>
              </div>
                 </div>

                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <button id="addPerksBtn" type="submit" className="btn btn-primary mt-10" style={{maxWidth:"200px"}}> Update Perks</button>
                 </div>
                 </div>

              </div>
                 </div>

                 </div>

                 <div id="successMessage" className="alert alert-success" role="alert">Perks has been updated successfully</div>

                 <div id="failMessage" className="alert alert-danger" role="alert">Please try again</div>


               </div>
             </div>
             </form>

             <div className={`card`}>

     {/* begin::Body */}
     <div className='card-body py-3'>
       {/* begin::Table container */}
       <div className='table-responsive'>
         {/* begin::Table */}
         <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
           {/* begin::Table head */}
           <thead>
             <tr className='fw-bolder text-muted'>
             <th className='min-w-140px'></th>
               <th className='min-w-140px'>Perks Category</th>
               <th className='min-w-140px'>Perks Title</th>
             </tr>
           </thead>
           <tbody>
           {
                existingPerks.map((data, index) => (
                            <tr>
                            <td style={{maxWidth: "35px"}}><input name="companyuserperk" value={data.perksId} className="form-check-input" type="checkbox" id="defaultCheck1" /></td>
                            <td>{(data.perksCatTitle == '' || data.perksCatTitle == null) ? '--' : data.perksCatTitle}</td>
                            <td className="perk-icon">
                            <span><img src={data.perksImageUrl} alt="" /></span> {data.perksTitle == '' || data.perksTitle == null ? '--' :  data.perksTitle }

                            </td>
                            </tr>
            ))}

           </tbody>
           {/* end::Table body */}
         </table>


         {/* end::Table */}
       </div>

       <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <a  id="removeCompanyPerk" style={{maxWidth:"200px"}} className="btn btn-primary mt-10">Remove Perks</a>
                 </div>
                 </div>

              </div>
                 </div>

       {/* end::Table container */}
     </div>
     <div id="successMessageDel" className="alert alert-success" role="alert">Selected Perk(s) has been deleted successfully</div>

     <div id="failMessageDel" className="alert alert-danger" role="alert">Please try again</div>
     {/* begin::Body */}
   </div>
    </>
  )
}
export { PerksList }